<template>
    <div class="input-row col-12" :class="{ error }">
        <div class="row d-flex align-items-center">
            <label class="col-12 col-sm"> <slot name="label"></slot> <span v-if="required" class="required">*</span> </label>
            <div class="col-12 col-sm-9"><slot name="input"></slot></div>
        </div>
        <div class="error-message" v-show="error">{{ error }}</div>
    </div>
</template>

<script>
export default {
    name: "BaseInput",
    props: {
        required: {
            type: Boolean,
            default: false,
            required: false
        },
        error: {
            default: undefined,
            required: false
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";
@import "../../../assets/css/media";

.input-row {
    &.error .error-message,
    &.error .required {
        color: $error-color;
        font-style: italic;
        text-transform: initial;
    }
    label {
        font-size: 18px;
        font-weight: bold;
        font-family: "Oswald", sans-serif;
    }
    input {
        font-family: "oswald-regular", sans-serif;
    }
}
</style>



// WEBPACK FOOTER //
// DefaultBaseInput.vue?18814d82